<!-- <ngx-loading [show]="loading"></ngx-loading> -->
<div [formGroup]="form" class="make-responsive">
    <div class="mt-top-2 field date-field">
        <mat-form-field>
            <mat-label>DOB</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dob" [max]="maxDate" (click)="picker.open()"
                readonly>
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="gender">
                <mat-option class="text-capitalize" *ngFor="let option of genderList" [value]="option.name" selected>
                    {{option.name | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Nationality</mat-label>
            <mat-select formControlName="nationality" (closed)="triggerEvent($event)"
                (focus)="clearDropDownSearch=false" [disableOptionCentering]="true" panelClass="mwPanel">
                <app-search-dropdown (searchItem)="searchTerm=$event" class="d-flex border-bottom mb-4"
                    [clearSearch]="clearDropDownSearch">
                </app-search-dropdown>
                <mat-option class="text-capitalize"
                    *ngFor="let option of nationalityList | commonSearch:searchTerm:'nationality'"
                    [value]="option.nationality" selected>
                    {{option.nationality | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Blood Group</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="bloodGroup">
                <mat-option class="text-capitalize" *ngFor="let option of bloodGroupList" [value]="option.value"
                    selected>
                    {{option.value}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>